import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import container from 'containers/Alert';
import StandardButton from 'components/shared/StandardButton';
import { ReactComponent as XIcon } from 'assets/images/svg/x.svg';

export const Alert = ({
  isVisible, title, description, closeAlert,
}) => (
  <ReactModal
    id="alert"
    isOpen={isVisible}
    ariaHideApp={false}
    className="absolute inset-x-0 mx-auto bg-white outline-none modal-y-inset-top font-primary rounded-4 md:max-w-md"
    overlayClassName="fixed inset-0 bg-dark-grey-three bg-opacity-70 z-50"
    onRequestClose={closeAlert}
  >
    <div className="p-2">
      <XIcon
        id="close-alert"
        onClick={closeAlert}
        className="w-10 h-10 cursor-pointer"
      />
      <div className="p-3 bg-blue">
        <div className="flex flex-col items-center space-y-2">
          <span id="alert-title" className="font-semibold text-5">{title}</span>
          <span id="alert-description" className="font-medium text-center text-4">
            {description}
          </span>
        </div>
        <div className="flex flex-col mt-10 space-y-3">
          <StandardButton
            text="Done"
            heightStyle="h-12"
            id="alert-done"
            onClick={closeAlert}
          />
        </div>
      </div>
    </div>
  </ReactModal>
);

Alert.propTypes = {
  closeAlert: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default container(Alert);
